import { render, staticRenderFns } from "./PollMatrixEditorDesktop.vue?vue&type=template&id=97e51b60&scoped=true"
import script from "./PollMatrixEditorDesktop.vue?vue&type=script&lang=js"
export * from "./PollMatrixEditorDesktop.vue?vue&type=script&lang=js"
import style0 from "./PollMatrixEditorDesktop.vue?vue&type=style&index=0&id=97e51b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e51b60",
  null
  
)

export default component.exports